export default __webpack_public_path__ + "static/media/sticker-S.75739148.png";